import React from "react";
import "./Contact_Us.css";
import Contact_Form from "./contact_form/Contact_Form";
import Common_Banner from "../common-components/common_banner/Common_Banner";

const Contact_Us = () => {
  return (
    <div className="Contact_Us">
      <Common_Banner imgSrc="/assets/images/contact_us/banner.png"/>
      <Contact_Form/>
    </div>
  );
};

export default Contact_Us;
